module.exports = __webpack_public_path__ + "fonts/subset-MullerUltraLight.4fb31465.woff2";